
import { Fraga } from "@/types/riskbedomning";

export const trafficRiskFragor: Fraga[] = [
  {
    id: "fordonstrafik",
    text: "Finns det risk att arbete utförs på en plats eller ett område där fordonstrafik passerar?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns risk från passerande trafik (väg/spår) nära arbete?",
      "Saknas åtgärder som sänkt hastighet/omledning/avspärrning/markeringar?",
      "Finns det risk att särskilda åtgärder krävs för att säkra arbetsområdet och skyddsbarriärer?"
    ]
  }
];
